export default __webpack_public_path__ + "static/media/logo.d75ab5d9.svg";